export const filter = {
    company_id: null, 
    client_id: null, 
    user_id: null,
    filial_id: null  
};
  